const urlRoot = '/delay-repay';

export const URL = {
    subscribe: `${urlRoot}/auto/subscribe`,
};
